import React from "react";
import { BaseComponent } from "../baseComponent/BaseComponent";
import { OpenAuctionWithDeposit } from "./OpenAuctionWithDeposit";

export class OpenAuctionWithDepositParticipant extends OpenAuctionWithDeposit {
    constructor(props) {
        super(props);
    }

    detailsMenu() {
        return (
            <div className="lotDetails">
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Documents" })}
                    className={this.state.ActiveMenu === "Documents" && "active"}
                >Мои документы</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Bets" })}
                    className={this.state.ActiveMenu === "Bets" && "active"}
                >Ставки({this.state.Lot?.Bets?.length > 0 ? this.state.Lot?.Bets?.length : 0})</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Applications" })}
                    className={this.state.ActiveMenu === "Applications" && "active"}
                >Моя заявка</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "LotDetails" })}
                    className={this.state.ActiveMenu === "LotDetails" && "active"}
                >Детали</button>
            </div>
        )
    }

    ShortInfoLot() {
        return (
            <React.Fragment>
                <div className="cardContent">
                    <div className="cardImage">
                        <a href={"/TradeLot/View/" + this.state.Lot.Id}>
                            {(this.state.Lot.Picture && this.state.Lot.Picture.ThumbnailUrl && this.state.Lot.Picture.ThumbnailUrl.length > 0) ?
                                <img className="img-100w" key={this.state.Lot.Picture.Id} src={this.state.Lot.Picture.ThumbnailUrl} alt={this.state.Lot.Picture.FileName} />
                                :
                                <img src="../../main-images/defaultLotImage.png" className="img-100w" alt="Картинка по умолчанию" />
                            }
                        </a>
                    </div>
                    <div className="cardInfo">
                        {this.renderTradeHint()}
                        {this.state.Lot?.DateCreated && <p className="dateCreatedLot defaultDescription">Дата создания: {this.GetDate(this.state.Lot?.DateCreated)}</p>}

                        <a className="cardName" href={"/TradeLot/View/" + this.state.Lot.Id}>
                            {this.state.Lot.Name}
                        </a>

                        <div className="cardDescription">
                            <div className="cartType cardDescriptionItem">
                                <h5>Тип торга:</h5>
                                <span>{this.state.Lot.TradeTypeDescription} {this.renderIsDeposit()}</span>
                            </div>
                            <div className="cardTypeSale cardDescriptionItem">
                                <h5>Статус:</h5>
                                <span>{this.state.Lot.LotTradeStatusDescription}</span>
                            </div>
                            <div className="cardNumber cardDescriptionItem">
                                <h5>Номер лота:</h5>
                                <span>{this.state.Lot.Id}</span>
                            </div>
                            <div className="cardPrice cardDescriptionItem">
                                <h5>Текущая цена:</h5>
                                <span>{this.state.Lot.CurrentPrice ? this.state.Lot.CurrentPrice : this.state.Lot.BasePrice} ₽</span>
                            </div>
                        </div>

                        <div className="cardActions">
                            {this.detailsMenu()}
                        </div>
                    </div>
                </div>
                <div className="details" style={{ position: "relative" }}>
                    {this.activeDetails()}
                </div>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.ShortInfoLot()}
            </React.Fragment>
        )
    }
}